import React from 'react';
import {
  Button,
  Col,
  Row,
  FormGroup,
  Input,
  Label
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faClone } from '@fortawesome/free-solid-svg-icons';

const EditItemShippingDetails = ({
  index,
  id,
  formData,
  handleInputChange,
  isInvalid,
  artaSubtypeList,
  deleteObject,
  copyObject,
  confidenceScoresPerFields,
  isManuallyModified,
  single,
  onFieldFocus,
}) => {
  const handleChange = (e) => {
    handleInputChange(id, e.target.name, e.target.value);
  };

  const handleFocus = (e) => {
    if (onFieldFocus) {
      onFieldFocus(id, e.target.name);
    }
  };

  const onDeleteObject = () => {
    deleteObject(index);
  };

  const onCopyObject = () => {
    copyObject(index);
  };

  const getConfLevelClassName = (score, isModified) => {
    if (isModified) return '';
    if (score === null || score === undefined || score >= 0.8) return '';
    if (score >= 0.5) return 'color-warning';
    return 'color-error';
  };

  return (
    <>
      <Row className="mb-4">
        <Col md={12}>
          <FormGroup>
            <Row className="mb-2">
              <Col className="d-flex align-items-center">
                <Label for={`title-${index}`} className="fw-bold mb-0">Object Name*</Label>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button color="link" onClick={onCopyObject}>
                  <FontAwesomeIcon icon={faClone} />
                  <span> Copy Object</span>
                </Button>
                {!single && (
                  <Button color="link" className="color-error" onClick={onDeleteObject}>
                    <FontAwesomeIcon icon={faTrash} color="danger" />
                    <span> Delete Object</span>
                  </Button>
                )}
              </Col>
            </Row>
            <Input
              type="text"
              name={`title-${index}`}
              id={`title-${index}`}
              value={formData.items[index].title}
              placeholder="Enter Object Name"
              onChange={handleChange}
              onFocus={handleFocus}
              className={isInvalid?.[id]?.title === true ? 'is-invalid' : ''}
            />
            {isInvalid?.[id]?.title === true && (
              <p className="color-error my-0">
                Enter Title
              </p>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <FormGroup>
            <Label for={`artaSubtype-${index}`} className="fw-bold">
              Object Type*
            </Label>
            <Input
              type="select"
              name={`artaSubtype-${index}`}
              id={`artaSubtype-${index}`}
              value={formData.items[index].artaSubtype}
              onChange={handleChange}
              onFocus={handleFocus}
              className={isInvalid?.[id]?.artaSubtype === true ? 'is-invalid' : getConfLevelClassName(confidenceScoresPerFields?.artaSubtype, isManuallyModified)}
            >
              <option key="noId" value="">Please Select Object Type</option>
              {artaSubtypeList.map((item) => (
                <option key={item.id} value={item.id}>{item.name}</option>
              ))}
            </Input>
            {isInvalid?.[id]?.artaSubtype === true ? (
              <p className="color-error my-0">
                Select Object Type
              </p>
            ) : confidenceScoresPerFields?.artaSubtype < 0.8 && (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.artaSubtype, isManuallyModified)} my-0`}>Review Object Type</p>
            )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for={`isFragile-${index}`} className="fw-bold">
              Fragile
            </Label>
            <Input
              type="select"
              name={`isFragile-${index}`}
              id={`isFragile-${index}`}
              value={formData.items[index].isFragile}
              onChange={handleChange}
              onFocus={handleFocus}
              className={getConfLevelClassName(confidenceScoresPerFields?.isFragile, isManuallyModified)}
            >
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Input>
            {confidenceScoresPerFields?.isFragile < 0.8 && (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.isFragile, isManuallyModified)} my-0`}>Review Fragility</p>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={3}>
          <FormGroup>
            <Label for={`height-${index}`} className="fw-bold">
              Height*
            </Label>
            <Input
              type="text"
              name={`height-${index}`}
              id={`height-${index}`}
              value={formData.items[index].height}
              onChange={handleChange}
              onFocus={handleFocus}
              className={isInvalid?.[id]?.height === true ? 'is-invalid' : getConfLevelClassName(confidenceScoresPerFields?.height, isManuallyModified)}
            />
            {isInvalid?.[id]?.height === true ? (
              <p className="color-error my-0">
                Enter Dimensions
              </p>
            ) : confidenceScoresPerFields?.height < 0.8 ? (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.height, isManuallyModified)} my-0`}>Review Value</p>
            ) : null}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for={`width-${index}`} className="fw-bold">
              Width*
            </Label>
            <Input
              type="text"
              name={`width-${index}`}
              id={`width-${index}`}
              value={formData.items[index].width}
              onChange={handleChange}
              onFocus={handleFocus}
              className={isInvalid?.[id]?.width === true ? 'is-invalid' : getConfLevelClassName(confidenceScoresPerFields?.width, isManuallyModified)}
            />
            {isInvalid?.[id]?.width === true ? (
              <p className="color-error my-0">
                Enter Dimensions
              </p>) : confidenceScoresPerFields?.width < 0.8 ? (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.width, isManuallyModified)} my-0`}>Review Value</p>
            ) : null}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for={`depth-${index}`} className="fw-bold">
              Depth*
            </Label>
            <Input
              type="text"
              name={`depth-${index}`}
              id={`depth-${index}`}
              value={formData.items[index].depth}
              onChange={handleChange}
              onFocus={handleFocus}
              className={isInvalid?.[id]?.depth === true ? 'is-invalid' : getConfLevelClassName(confidenceScoresPerFields?.depth, isManuallyModified)}
            />
            {isInvalid?.[id]?.depth === true ? (
              <p className="color-error my-0">
                Enter Dimensions
              </p>
            ) : confidenceScoresPerFields?.depth < 0.8 ? (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.depth, isManuallyModified)} my-0`}>Review Value</p>
            ) : null}
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for={`unitOfMeasurement-${index}`} className="fw-bold">
              Unit
            </Label>
            <Input
              type="select"
              name={`unitOfMeasurement-${index}`}
              id={`unitOfMeasurement-${index}`}
              value={formData.items[index].unitOfMeasurement}
              onChange={handleChange}
              onFocus={handleFocus}
              className={getConfLevelClassName(confidenceScoresPerFields?.unitOfMeasurement, isManuallyModified)}
            >
              <option value="in">In</option>
              <option value="cm">Cm</option>
            </Input>
            {confidenceScoresPerFields?.unitOfMeasurement < 0.8 && (
              <p className={`${getConfLevelClassName(confidenceScoresPerFields?.unitOfMeasurement, isManuallyModified)} my-0`}>Review Value</p>
            )}
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label for={`notes-${index}`} className="fw-bold">
          Additional Shipping Notes
        </Label>
        <Input
          type="textarea"
          name={`notes-${index}`}
          id={`notes-${index}`}
          value={formData.items[index].notes || ''}
          onChange={handleChange}
          onFocus={handleFocus}
          rows="2"
        />
      </FormGroup>
    </>
  );
};

export default EditItemShippingDetails;
